module.exports = __webpack_public_path__ + "static/img/001.72975720.png";